import React from 'react';
import { observer } from 'mobx-react-lite';
import { userInfoStore } from '@pascal/pascal-core/shared/core/store';
import { isMobile, useTranslation } from '@pascal/pascal-core';
import { winningAmountStore } from '../../store/winningAmountStore';

export const WinPopup = observer(() => {
  const { winningAmount, isFinishedRound } = winningAmountStore;
  const { currencySymbolOrCode } = userInfoStore;
  const t = useTranslation();

  if (!winningAmount || !isFinishedRound) {
    return null;
  }

  return (
    <div className={`${isMobile() ? 'm' : 'web'}-win-popup`}>
      <div className={`${isMobile() ? 'm' : 'web'}-win-popup-inner`}>
        <p className={`${isMobile() ? 'm' : 'web'}-win-popup-title`}>{t('YOU_WIN')}</p>
        <p className={`${isMobile() ? 'm' : 'web'}-win-popup-info`}>
          {winningAmount} {currencySymbolOrCode}
        </p>
      </div>
    </div>
  );
});
